// extracted by mini-css-extract-plugin
export default {"video-section":"t_b4 d-flex","video-section--header":"t_b5","video-section__frame":"t_b6 ml-3"};